
<template>
  <vx-card title="Overview" collapse-action class="overflow-hidden">
    <div slot="no-body-bottom" v-if="live">
      <feather-icon
        :style="active ? 'margin-left: 450px' : 'margin-left:  9px'"
        style="
          position: absolute !important;
          z-index: 99;
          margin-top: 10px;
          background: white;
          height: 50px; /* text-align: center; */
          font-size: 41px;
          width: 50px;
          margin-left: 9px;
          border-radius: 68px;
        "
        class="mr-0 cursor-pointer"
        :icon="'ArrowLeftIcon'"
        svg-classes="stroke-current text-primary"
        @click="active = !active"
      />
      <div class="mt-5" style="display: flex; justify-content: flex-end">
        <gmap-map
          v-if="live.point"
          :style="active ? 'width: 85%' : 'width:  100%'"
          :center="{
            lat: live.point.coordinates[1],
            lng: live.point.coordinates[0],
          }"
          :zoom="10"
          style="height: 78vh"
        >
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen = false"
          >
            {{ infoContent }}
          </gmap-info-window>
          <gmap-marker
            v-if="live.point"
            :icon="arrow_icon"
            :position="{
              lat: live.point.coordinates[1],
              lng: live.point.coordinates[0],
            }"
            :clickable="true"
            @click="toggleInfoWindow(m, i)"
          ></gmap-marker>
        </gmap-map>
      </div>
      <vs-sidebar
        style="max-width: 300px !important"
        :hidden-background="true"
        default-index="1"
        color="primary"
        class="sidebarx sidebarpage sidebar-demo-parent bordered-sidebar"
        spacer
        v-model="active"
      >
        <component
          :is="scrollbarTag"
          class="scroll-area--bordered-sidebar"
          ref="verticalNavMenuPs"
          @ps-scroll-y="psSectionScroll"
          @scroll="psSectionScroll"
          :settings="settings"
        >
          <div class="lists">
            <div class="list">
              <div class="header" v-if="live.driver">
                <strong class="number" style="font-size: 24px"
                  >{{ live.driver.name }} {{ live.driver.last_name }} (Model:
                  {{ live.truck.model }})</strong
                >
                <vs-button color="primary" type="filled"
                  >{{ live.speed }}MPH</vs-button
                >
              </div>
              <div
                class="bottom mt-4"
                style="display: flex; flex-direction: column"
              >
                <span class="map">
                  <feather-icon
                    icon="MapPinIcon"
                    svgClasses="h-5 w-5 mr-3 text-success"
                  />{{ live.country }}
                  <br />
                  <feather-icon
                    icon="ClockIcon"
                    svgClasses="h-5 w-5 mr-2 text-success"
                  />
                  <span class="">
                    {{ $dayjs(live.created_at).format("DD MMM YYYY hh:mm") }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <vs-collapse accordion class="accordion">
            <vs-collapse-item>
              <div slot="header">Asset stats</div>
              <div class="asset" v-if="live.driver">
                <p>Licence plate</p>
                <p>{{ live.driver.driver_license_number }}</p>
              </div>
              <div class="stats">
                <p>VIN</p>
                <p>{{ live.vin }}</p>
              </div>
            </vs-collapse-item>
          </vs-collapse>
          <vs-collapse accordion class="accordion">
            <vs-collapse-item>
              <div slot="header">Diagnostics</div>
              <div class="diag">
                <p>Engine State</p>
                <p>{{ live.engine_state ? "Running" : "Off" }}</p>
              </div>
              <div class="diag">
                <p>Engine Hours</p>
                <p>{{ live.engine_hours }}h</p>
              </div>
              <div class="diag">
                <p>Odometr</p>
                <p>{{ live.odometer }} ml</p>
              </div>
              <div class="diag">
                <p>Fuel</p>
                <p>{{ live.fuel_level }}%</p>
              </div>
              <div class="diag">
                <p>DEF Level</p>
                <p>{{ live.def_level }}%</p>
              </div>
              <div class="diag">
                <p>BUS</p>
                <p>{{ live.bus }}%</p>
              </div>
              <div class="diag">
                <p>Coolant level percent</p>
                <p>{{ live.coolant_level }}%</p>
              </div>
              <div class="diag">
                <p>Coolant temperature</p>
                <p>{{ live.coolant_temperature }}</p>
              </div>
              <div class="diag">
                <p>Oil level percent</p>
                <p>{{ live.oil_level }}%</p>
              </div>
              <div class="diag level">
                <p>Oil temperature</p>
                <p>{{ live.oil_temperature }}</p>
              </div>
            </vs-collapse-item>
          </vs-collapse>
          <vs-collapse accordion class="accordion">
            <vs-collapse-item>
              <div slot="header">Trip history</div>
              <vs-tabs>
                <vs-tab label="Trips">
                  <div class="tab-text">
                    <div class="hopewell">
                      <p class="circlea">B</p>
                      <p>Hopewell,TX 8-57 PM (1h 10m)</p>
                      <p>77.4 ml</p>
                      <img
                        class="img"
                        src="https://i.playground.ru/i/pix/1975775/image.jpg"
                        alt=""
                      />
                    </div>
                    <div class="hopewell">
                      <p class="circleb">A</p>
                      <p>
                        Loop 151, Texarkani Apr 30, 7:47 PM <br />
                        Driver: COTTO,ANGEL <br />
                        Coddriver:CASTRO,LUIS <br />
                        Trailer:Dmwl275
                      </p>
                      <router-link tag="div" to="/" class="show"
                        >Show trip images</router-link
                      >
                    </div>
                  </div>
                </vs-tab>
                <vs-tab label="Routes">
                  <div class="tab-text"></div>
                </vs-tab>
              </vs-tabs>
            </vs-collapse-item>
          </vs-collapse>
        </component>
      </vs-sidebar>
    </div>
  </vx-card>
</template>
<script>
import dayjs from "dayjs";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import arrow_icon from "@/assets/images/map-icons/arrow_icon.svg";
export default {
  data() {
    return {
      active: true,
      value1: "",
      arrow_icon: arrow_icon,
      infoContent: "",
      showShadowBottom: false,
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    live() {
      return this.$store.state.event.live;
    },
  },
  methods: {
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    psSectionScroll() {
      const scroll_el =
        this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
      this.showShadowBottom = scroll_el.scrollTop > 0;
    },
  },

  components: {
    VuePerfectScrollbar,
  },
  created() {
    this.$store.dispatch("event/fetchDataLive", this.$route.params.id);
    // setInterval(() => {
    this.$store.dispatch("log/fetchDataTrip", this.$route.params.id);
    // }, 10000);
  },
};
</script>
<style scoped>
.list {
  padding: 20px;
  border-bottom: 1px solid lightgray;
}

.img {
  width: 100%;
  margin-bottom: 10px;
}

.text {
  margin-bottom: 30px;
}

span {
  text-decoration: underline;
  margin-bottom: 5px;
  font-size: 20px;
}

.date {
  margin-left: 30px;
  margin-bottom: 50px;
  color: lightgray;
}

.map {
  text-decoration: none;
}

.accordion {
  border-bottom: 1px solid lightgray;
}

.asset {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid lightgray;
  padding-bottom: 5px;
}

.stats {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 5px;
}

.diag {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid lightgray;
  margin-top: 5px;
}

.diag p {
  margin-bottom: 10px;
}

.level {
  border-bottom: none;
  margin-bottom: 20px;
}
.hopewell {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.hopewell p {
  margin-right: 10px;
  font-size: 12px;
}
.hopewell .img {
  width: 100px;
  height: 50px;
}
.tab-text:hover {
  background-color: blue;
  color: #fff;
}
.view {
  color: blue;
}
.gate {
  text-decoration: underline;
  margin-bottom: 10px;
}

.vs-button {
  padding: 0.5rem 1rem !important;
  float: right;
  font-size: 11px;
  font-weight: 700;
}

.feather-arrow-left {
  margin-left: 8px;
  height: 102px;
  width: 35px;
}

.vuesax-app-is-ltr .vs-sidebar {
  left: 0;
  max-width: 300px !important;
}
</style>
<style lang="scss" scoped>
.vs-content-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 2010;
    width: 450px;
    max-width: 90vw;
  }
}

.scroll-area--bordered-sidebar {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: 100%;

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
